import endpoints, {
    assistantEndpoints,
} from '../../../utils/commonVariables/endpoints';
import api, { assistantApi } from '../../../services/api';
import { ServiceScraperResponse } from '../types/serviceScraperResponseTypes';
import { ScraperCategory } from '../types/scrapedServicesTypes';
import { adaptScrapedServicesStateToDDBB } from './adapters/scrapedServicesAdapter';
import { hotelContentViewModel } from '../utils/viewModels/childHotelContent';
import { savableEntities } from '../../../utils/commonVariables/entityKeys';
import { convertToOvariant } from '../../../utils/convertToOvariant';
import { IHotel } from '../../../types/entities/IHotel';

export const scrapeServices = async (
    hotelId: number,
    urlToScrape: string,
    categoriesToSearch: string[],
    promptKey: string
): Promise<ServiceScraperResponse> => {
    const response = await assistantApi.post<ServiceScraperResponse>(
        assistantEndpoints.scrapeServices,
        {
            hotelId,
            categoriesToSearch,
            scrapingUrl: urlToScrape,
            locale: 'en',
            threadId: null,
            timeoutSeconds: 480,
            promptKey,
        }
    );
    return response.data;
};

export const saveScrapedServices = async (
    scrapedData: ScraperCategory[],
    hotelId: number,
    idSysUser: number
) => {
    const adaptedData = adaptScrapedServicesStateToDDBB(
        scrapedData,
        hotelId,
        idSysUser
    );
    const objectBase64 = convertToOvariant(
        savableEntities.Hotel,
        adaptedData,
        hotelId,
        hotelContentViewModel
    );

    return api.post<Partial<IHotel>>(endpoints.commonSave, objectBase64);
};
